// src/pages/ReportPage.js

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDailyReport,
  updateDailyReport,
} from '../actions/dailyReportActions';
import { fetchGroupReports } from '../actions/groupReportActions';
import { fetchChildrenWithReportStatus } from '../actions/reportActions';
import {  } from '../actions/mealActions';
import ReportsTable from '../components/ReportsTable';
import {
  TextField,
  Button,
  Typography,
  Container,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ReportPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const date = new Date().toISOString().split('T')[0];

  // Fetch data from Redux store
  const dailyReport = useSelector((state) => state.dailyReport.dailyReport);
  const groupReports = useSelector((state) => state.groupReports.groupReports);
  const childrenWithStatus = useSelector(
    (state) => state.reports.childrenWithStatus
  );

  // Local state for daily report inputs
  const [photoLink, setPhotoLink] = useState('');
  const [generalInfo, setGeneralInfo] = useState('');
  const [mealPlan, setMealPlan] = useState('');

  // Fetch data on component mount
  useEffect(() => {
    dispatch(fetchDailyReport(date));
    dispatch(fetchGroupReports(date));
    dispatch(fetchChildrenWithReportStatus());
  }, [dispatch, date]);

  // Update local state when dailyReport changes
  useEffect(() => {
    if (dailyReport) {
      setPhotoLink(dailyReport.photo_link || '');
      setGeneralInfo(dailyReport.general_info || '');
    } else {
      setPhotoLink('');
      setGeneralInfo('');
    }
  }, [dailyReport]);

  const handleDailyReportSave = () => {
    dispatch(
      updateDailyReport({
        date,
        photo_link: photoLink,
        general_info: generalInfo,
      })
    );
  };

  // Function to navigate back to Teacher Dashboard
  const handleBackToDashboard = () => {
    navigate('/teacher-dashboard');
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Report Creation - {date}
      </Typography>

      {/* General Data */}
      <Typography variant="h6" gutterBottom>
        General Information
      </Typography>
      <TextField
        label="Photo Link"
        fullWidth
        margin="normal"
        value={photoLink}
        onChange={(e) => setPhotoLink(e.target.value)}
      />
      <TextField
        label="General Information"
        fullWidth
        margin="normal"
        multiline
        rows={4}
        value={generalInfo}
        onChange={(e) => setGeneralInfo(e.target.value)}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleDailyReportSave}
        style={{ marginBottom: '20px' }}
      >
        Save General Information
      </Button>

      <Divider style={{ margin: '20px 0' }} />

      {/* Reports Table */}
      {childrenWithStatus && childrenWithStatus.length > 0 ? (
        <ReportsTable
          children={childrenWithStatus}
          groupReports={groupReports}
          date={date}
          mealPlan={mealPlan}
        />
      ) : (
        <div>No children to display.</div>
      )}

      {/* Back to Dashboard Button */}
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleBackToDashboard}
        style={{ marginTop: '20px' }}
      >
        Back to Dashboard
      </Button>
    </Container>
  );
};

export default ReportPage;
